import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationRootCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    ${communicationRootCss}
    background-color: ${COLORS.GRAY_100};
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    padding-bottom: calc(var(--sab, 0px) + 24px);
    height: 100%;
    overflow-y: auto;
  `,

  StyledForm: styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
  `,

  TitleGroup: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  Title: styled.h1`
    font-family: 'Mulish', sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    color: ${COLORS.BLACK};
    text-align: center;
  `,

  Subtitle: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLORS.BLACK_ALPHA_50};
    text-align: center;
  `,

  EmailFieldWrapper: styled.div`
    width: 100%;
    position: relative;

    &[data-valid='false'] > div {
      outline: 1.5px solid #ef4444;
    }

    &[data-valid='false']::after {
      content: attr(data-validation-text);
      display: block;
      color: #ef4444;
      font-family: 'Mulish', sans-serif;
      font-size: 13px;
      line-height: 18px;
      margin-top: 4px;
      margin-left: 4px;
    }
  `,

  EmailInputInner: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 64px;
    padding: 0 16px;
    background: ${COLORS.WHITE};
    border-radius: 16px;
    outline: 1px solid #eaeaed;
  `,

  MailIconWrapper: styled.span`
    flex-shrink: 0;
    display: flex;
    align-items: center;
  `,

  EmailInput: styled.input`
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: 'Mulish', sans-serif;
    font-size: 17px;
    font-weight: 400;
    line-height: 24px;
    color: ${COLORS.BLACK};

    &::placeholder {
      color: ${COLORS.BLACK_ALPHA_50};
    }
  `,

  PrivacyRow: styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
  `,

  LockIcon: styled.span`
    flex-shrink: 0;
    display: flex;
    align-items: center;
  `,

  PrivacyText: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLORS.BLACK_ALPHA_50};
  `,

  CheckboxRow: styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;
  `,

  CheckboxContainer: styled.div`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  `,

  Checkbox: styled.div<{ $checked: boolean }>`
    width: 16px;
    height: 16px;
    border-radius: 6px;
    border: 2px solid ${({ $checked }) => ($checked ? '#096ef9' : '#d1d5db')};
    background: ${COLORS.WHITE};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s;
  `,

  CheckboxLabel: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLORS.GRAY_700};
  `,

  StyledButton: styled(Button)`
    ${communicationButtonCss}
    width: 100%;
    margin-top: auto;
  `,
} as const
